import { Injectable } from '@angular/core';
import { containerBootstrap } from '@nlpjs/core';
import { Nlp } from '@nlpjs/nlp';
import { LangIt } from '@nlpjs/lang-it';
import { NluClassification } from './nlu.model';
import { TRAINING_DATA } from './intent-training-data';

export const NLU_CONFIDENCE_THRESHOLD = 0.70;

@Injectable({ providedIn: 'root' })
export class NluEngineService {
  private nlpManager: any = null;
  private initPromise: Promise<void> | null = null;

  async ensureReady(): Promise<void> {
    if (this.nlpManager) return;
    if (!this.initPromise) {
      this.initPromise = this.initialize().catch(err => {
        this.initPromise = null; // Allow retry on failure
        throw err;
      });
    }
    return this.initPromise;
  }

  private async initialize(): Promise<void> {
    const container = await containerBootstrap();
    container.use(Nlp);
    container.use(LangIt);

    const nlp = container.get('nlp');
    nlp.settings.autoSave = false;
    nlp.settings.log = false;
    nlp.addLanguage('it');

    for (const data of TRAINING_DATA) {
      for (const utterance of data.utterances) {
        nlp.addDocument('it', utterance, data.intent);
      }
    }

    await nlp.train();
    this.nlpManager = nlp;
  }

  async classify(text: string): Promise<NluClassification> {
    await this.ensureReady();

    if (!text || !text.trim()) {
      return { intent: null, score: 0 };
    }

    const result = await this.nlpManager.process('it', text);
    const intent = result.intent;
    const score = result.score ?? 0;

    if (!intent || intent === 'None' || score < NLU_CONFIDENCE_THRESHOLD) {
      return { intent: null, score: 0 };
    }

    return { intent, score };
  }
}
